import React from "react";
import { useTable, List, EditButton, ShowButton, DeleteButton, CreateButton } from "@refinedev/antd";
import { Table, Space, Tag } from "antd";
import { PERMISSION_LIST_QUERY, DELETE_PERMISSION_MUTATION } from "./queries";

interface IPermission {
  id: string;
  organizationalRoles: string[];
  resources: string[];
  actions: string[];
}

export const PermissionList: React.FC = () => {
  const { tableProps } = useTable<IPermission>({
    resource: "permissions",
    initialPageSize: 10,
    meta: {
      gqlQuery: PERMISSION_LIST_QUERY,
    },
  });

  return (
    <List
      headerProps={{
        extra: (
          <Space>
            <CreateButton />
          </Space>
        ),
      }}
    >
      <Table {...tableProps} rowKey="id">
        <Table.Column
          dataIndex="resources"
          title="Resources"
          render={(resources: string[]) => (
            <Space wrap>
              {resources?.map((r) => (
                <Tag key={r} color={r === '*' ? 'red' : 'blue'}>
                  {r === '*' ? 'All' : r}
                </Tag>
              ))}
            </Space>
          )}
        />
        <Table.Column
          dataIndex="actions"
          title="Actions"
          render={(actions: string[]) => (
            <Space wrap>
              {actions?.map((a) => (
                <Tag key={a} color={a === '*' ? 'red' : 'green'}>
                  {a === '*' ? 'All' : a}
                </Tag>
              ))}
            </Space>
          )}
        />
        <Table.Column
          dataIndex="organizationalRoles"
          title="Organizational Roles"
          render={(roles: string[]) => (
            <Space wrap>
              {roles?.map((role) => (
                <Tag key={role} color="orange">
                  {role}
                </Tag>
              ))}
            </Space>
          )}
        />
        <Table.Column
          title="Operations"
          render={(_text: string, record: IPermission) => (
            <Space>
              <EditButton size="small" recordItemId={record.id} />
              <ShowButton size="small" recordItemId={record.id} />
              <DeleteButton size="small" recordItemId={record.id} meta={{ gqlMutation: DELETE_PERMISSION_MUTATION }} />
            </Space>
          )}
        />
      </Table>
    </List>
  );
};
